<template>
  <div
    class="app-checkout-ident-data"
    :class="[isSingleIdentMethod ? 'single-ident-method' : '']"
  >
    <b-form
      :id="'form' + _uid"
      :novalidate="true"
      class="ident-input-form"
      ref="form">
        <slot name="txtHeadline"></slot>
      <IdentDataSelect
        :all-ident-methods='allIdentMethods'
        :ident.sync='selectedIdentCard'
        :nationality.sync='selectedNationality'
      >
        <template v-for="slot in possibleChildSlotsFor('IdentDataSelect')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </IdentDataSelect>
      <IdentMethodSelect v-if="notEmptyCountryOrPassport && validPassport"
                           :possible-ident-methods='possibleIdentMethods'
                           :selected-ident-method.sync='identType_'
                           :headline='headline'
      >
        <template v-for="slot in possibleChildSlotsFor('IdentMethodSelect')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </IdentMethodSelect>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import validationFlow from '@/mixins/validators/validationFlow'
import beErrors from '@/mixins/beErrors'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import syncProperty from '@/mixins/syncProperty'
import { splitError } from '@/helper/splitError'
import IdentDataSelect from '@/components/checkout/identData/IdentDataSelect.vue'
import IdentMethodSelect from '@/components/checkout/identData/IdentMethodSelect.vue'

export default {
  name: 'IdentData',
  data () {
    return {
      loading: false,
      allIdentMethods: {
        identTypes: []
      },
      selectedNationality: '',
      selectedIdentCard: '',
      showValidationError: false
    }
  },
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    headline: {
      type: String,
      default: 'h2'
    }
  },
  mixins: [
    validationMixin,
    validationFlow,
    beErrors,
    syncProperty('ident', 'identCard_'),
    syncProperty('nationality', 'nationality_'),
    syncProperty('identType', 'identType_')

  ],
  components: {
    IdentMethodSelect,
    IdentDataSelect
  },
  mounted () {
    this.$nextTick(() => {
      if (this.selectedNationality === '' && this.nationality_ && this.nationality_.name) {
        this.selectedNationality = this.nationality_.name
      }
      if (this.selectedIdentCard === '' && this.identCard_ && this.identCard_.name) {
        this.selectedIdentCard = this.identCard_.name
      }
    })
  },
  watch: {
    selectedNationality: function () {
      if (this.selectedNationality && this.allIdentMethods.identTypes.length !== 0) {
        this.nationality_ = this.allIdentMethods.identTypes.find((country) => {
          return (country.name.toLowerCase().indexOf(this.selectedNationality.toLowerCase()) === 0)
        })
      }
    },
    selectedIdentCard: function () {
      this.$nextTick(() => {
        if (!this.selectedIdentCard) {
          this.identCard_ = null
        } else if (this.selectedNationality && this.nationality_?.passports) {
          this.identCard_ = this.nationality_.passports.find(card => {
            return card.name === this.selectedIdentCard
          })
        }
      })
    },
    possibleIdentMethods: function () {
      this.$nextTick(() => {
        if (this.possibleIdentMethods.length === 0) {
          this.identType_ = null
        }
      })
    }
  },
  computed: {
    possibleIdentMethods: function () {
      let res = []
      if (this.notEmptyCountryOrPassport) {
        const possibleIdentForUser = this.nationality_?.passports?.find((passport) => {
          return (passport.name.toLowerCase().indexOf(this.selectedIdentCard.toLowerCase()) === 0)
        }) || []
        if (possibleIdentForUser.length !== 0) {
          res = possibleIdentForUser?.identMethods.filter((method) => {
            return (method === 'video' || method === 'store') // only 'video' and 'store', not 'door' etc
          }) || []
        }
      }
      return res
    },
    isSingleIdentMethod: function () {
      return this.possibleIdentMethods?.length === 1 || false
    },
    validPassport: function () {
      return this.selectedIdentCard !== ''
    },
    notEmptyCountryOrPassport: function () {
      return (this.selectedNationality !== '' && this.selectedIdentCard !== '')
    }
  },
  apollo: {
    allIdentMethods: function () {
      return wrapQuery(gql`query ${this.process} {
          allIdentMethods {
            identTypes {
              iso2,
              iso3,
              name,
              passports {
                identMethods,
                key,
                name
              }
            }
          }
        }`, this, 'allIdentMethods', {},
      () => {}, { fetchPolicy: 'cache-first' },
      (error) => {
        splitError(error).forEach(e => { this.errorMsg = e.message })
        this.errorToast(this.errorMsg)
        const data = { type: 'technical', message: this.errorMsg }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      })
    }
  }
}
</script>
